"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHealthCheckForm = void 0;
const core_1 = require("@veeam/core");
const types_1 = require("../types");
require("../models");
const HealthCheckHarmonizationManager_1 = require("../HealthCheckHarmonizationManager");
const useHealthCheckForm = (model, dailyScheduleModel, weeklyScheduleModel, monthlyScheduleModel, yearlyScheduleModel) => {
    const { value: healthCheckModelValue } = core_1.useModel(model);
    const { value: dailyScheduleModelValue } = core_1.useModel(dailyScheduleModel);
    const { value: weeklyScheduleModelValue } = core_1.useModel(weeklyScheduleModel);
    const { value: monthlyScheduleModelValue } = core_1.useModel(monthlyScheduleModel);
    const { value: yearlyScheduleModelValue } = core_1.useModel(yearlyScheduleModel);
    const isDayOfWeekControlVisible = HealthCheckHarmonizationManager_1.HealthCheckHarmonizationManager.isDayOfWeekControlVisible(healthCheckModelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
    const isDayOfMonthControlVisible = HealthCheckHarmonizationManager_1.HealthCheckHarmonizationManager.isDayOfMonthControlVisible(healthCheckModelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
    return core_1.useForm(model, {
        validationSchema: {
            fieldMonthValue: [
                core_1.conditions({
                    isEnabled: true,
                }, core_1.required()),
            ],
            fieldDayNumberInMonthValue: [
                core_1.conditions({
                    isEnabled: true,
                }, core_1.required()),
            ],
            fieldDayOfWeekValue: isDayOfWeekControlVisible
                ? [
                    core_1.conditions({
                        isEnabled: true,
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.first,
                    }, core_1.required()),
                    core_1.conditions({
                        isEnabled: true,
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.second,
                    }, core_1.required()),
                    core_1.conditions({
                        isEnabled: true,
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.third,
                    }, core_1.required()),
                    core_1.conditions({
                        isEnabled: true,
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.fourth,
                    }, core_1.required()),
                    core_1.conditions({
                        isEnabled: true,
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.last,
                    }, core_1.required()),
                ]
                : undefined,
            fieldDayOfMonthValue: isDayOfMonthControlVisible
                ? [
                    core_1.conditions({
                        isEnabled: true,
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.onDay,
                    }, core_1.required()),
                ]
                : undefined,
        },
    });
};
exports.useHealthCheckForm = useHealthCheckForm;
//# sourceMappingURL=useHealthCheckForm.js.map